module.exports = (__webpack_require__(8))(9);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/auth.js from dll-reference girder_lib
// module id = 352
// module chunks = 0